import { Component, OnInit } from '@angular/core';
import { Teacher } from 'src/app/models/teacher.model';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-instructor',
  templateUrl: './instructor.component.html',
  styleUrls: ['./instructor.component.css']
})
export class InstructorComponent implements OnInit {

  public showSpinner: boolean;

  teacher:Teacher = new Teacher()

  constructor(
    private route:ActivatedRoute,
    private firestore:AngularFirestore,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.getTeacher();
  }

  getTeacher(){
    let id = this.route.snapshot.params['id'];
    this.showSpinner = true;
    const id$ = new Subject<string>()
    const queryObservable = id$.pipe(
      switchMap(id =>
        this.firestore.collection('teachers').doc(id).get()
      )

    );
    // subscribe to changes
    queryObservable.subscribe(queriedItem => {
      console.log(queriedItem.data());
      var teacher = queriedItem.data() as Teacher
      teacher.id = queriedItem.id
      this.teacher = teacher
      this.showSpinner = false
    });

    // trigger the query
    id$.next(id)
  }

}
